import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=a68326be&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=a68326be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68326be",
  null
  
)

export default component.exports